import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LanguageSwitcher } from '../components/LanguageSwitcher';
import './Contact.css';

export function Contact() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="contact-page">
      <header className="page-header">
        <div className="container flex justify-between items-center">
          <a href="/" className="logo">
            <img src="/logo-header.png" alt="SolarMaktab" className="logo-img" />
          </a>
          <div className="header-actions">
            <LanguageSwitcher />
            <a href="/login" className="btn btn-outline btn-sm">{t('common.login')}</a>
          </div>
        </div>
      </header>

      <main className="contact-content">
        <div className="container">
          <div className="contact-hero">
            <span className="badge mb-md">{t('contact.badge', 'Contact')}</span>
            <h1>{t('contact.title', 'Get in Touch')}</h1>
            <p className="contact-subtitle">
              {t('contact.subtitle', 'Have questions? We\'d love to hear from you.')}
            </p>
          </div>

          <div className="contact-placeholder">
            <div className="placeholder-icon">📬</div>
            <h2>{t('contact.comingSoon', 'Contact Form Coming Soon')}</h2>
            <p>{t('contact.comingSoonText', 'We are setting up our contact channels. Please check back soon!')}</p>
            
            <div className="contact-temp-info">
              <p><strong>{t('contact.emailLabel', 'Email')}:</strong> info@solarmaktab.com</p>
            </div>
          </div>

          <div className="contact-actions">
            <button className="btn btn-primary" onClick={() => navigate('/')}>
              {t('common.back', 'Back to Home')}
            </button>
            <button className="btn btn-outline" onClick={() => navigate('/about')}>
              {t('footer.about', 'About Us')}
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}
